import React from 'react';
import ReactDOM from 'react-dom/client';
import ConnectWallet from './ConnectWallet';
import GameDetails from './GameDetails';
import EnterGame from './EnterGame';
import ClaimPrizes from './ClaimPrizes';
import InitialSequence from './InitialSequence';
import './App.css';
import Web3 from 'web3';
import Snowfall from 'react-snowfall';
import audioFile from './gongxi.mp3';
import image from './eggman1.JPG';
import imagePath1 from './1.png';
import imagePath2 from './2.png';
import imagePath3 from './3.png';
import imagePath4 from './4.png';
import imagePath5 from './5.png';

class Snowflake {
  constructor(x, y, speedX, speedY, size, image) {
    this.x = x;
    this.y = y;
    this.speedX = speedX;
    this.speedY = speedY;
    this.size = size;
    this.image = image;
  }

  update() {
    this.x += this.speedX;
    this.y += this.speedY;

    if (this.x > window.innerWidth) {
      this.x = 0;
    }

    if (this.y > window.innerHeight) {
      this.y = 0;
    }
  }

  draw(ctx) {
    ctx.drawImage(this.image, this.x, this.y, this.size, this.size);
  }
}

class App extends React.Component {
  canvasRef = React.createRef();
  state = {
    account: '',
    error: null,
    connectWallet: false,
    audioPlaying: false,
    showModal: true,
    snowflakes:[],
    isSequenceFinished: false, 
    showInitialSequence: true,
    web3: null 
  };

  //web3 = new Web3(Web3.givenProvider);

  handleConnectButton = async () => {
    const web3 = new Web3(Web3.givenProvider); // Initialise web3 here.
    const networkId = await web3.eth.net.getId(); // Get the network ID

    if (networkId !== 1) { 
      window.alert('Please switch to ethereum network.');
        return;
    }
    this.setState({ connectWallet: true, web3 }); // Update web3 in state.
 };

  handleClose = () => {
    this.setState({ showModal: false });
    this.toggleAudio();
  };

  onError = (error) => {
    this.setState({ error, connectWallet: false });
  };

  onConnect = (account) => {
    this.setState({ account, connectWallet: false });
  };

  handleSequenceFinish = () => {
    const imagePaths = [imagePath1, imagePath2, imagePath3, imagePath4, imagePath5];
    this.snowflakeImages = imagePaths.map(path => {
      const img = new Image();
      img.src = path;
      return img;
    });

    const snowflakes = this.createSnowflakes(this.canvasRef.current, this.snowflakeImages);
    this.setState({ snowflakes, isSequenceFinished: true });
  };

  componentDidMount() {
    this.setState({ audioPlaying: false }); 

    if (this.canvasRef.current) {
      this.canvasRef.current.width = window.innerWidth;
      this.canvasRef.current.height = window.innerHeight;
    }

    this.resizeListener = window.addEventListener('resize', () => {
      if (this.canvasRef.current) {
        this.canvasRef.current.width = window.innerWidth;
        this.canvasRef.current.height = window.innerHeight;
      }
    });

    if (this.state.isSequenceFinished) {
      this.animate();
    }

    if (window.ethereum) {
      window.ethereum.on('accountsChanged', (accounts) => {
        if (accounts.length === 0) {
          this.setState({ account: '' });
        } else if (accounts[0] !== this.state.account) {
          this.setState({ account: accounts[0] });
        }
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeListener);
    clearTimeout(this.audioTimeout);
  }

  createSnowflakes(canvas, images) {
    const snowflakes = [];
    for (let i = 0; i < 200; i++) {
      const x = Math.random() * canvas.width;
      const y = Math.random() * canvas.height;
      const speedX = Math.random() * 3 - 1.5;
      const speedY = Math.random() * 3 + 1;
      const size = Math.random() * 15 + 10;
      const img = images[Math.floor(Math.random() * images.length)];
      snowflakes.push(new Snowflake(x, y, speedX, speedY, size, img));
    }
    return snowflakes;
  }

  animate = () => {
    if (this.canvasRef.current) {
      const ctx = this.canvasRef.current.getContext('2d');
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      this.state.snowflakes.forEach(snowflake => {
        snowflake.update();
        snowflake.draw(ctx);
      });
      requestAnimationFrame(this.animate);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isSequenceFinished && this.state.isSequenceFinished) {
      this.animate();
    }

    if (this.canvasRef.current && this.state.snowflakes !== prevState.snowflakes) {
      const ctx = this.canvasRef.current.getContext('2d');
      ctx.clearRect(0, 0, this.canvasRef.current.width, this.canvasRef.current.height);
      this.state.snowflakes.forEach(snowflake => {
        snowflake.update();
        snowflake.draw(ctx);
      });
      requestAnimationFrame(this.animate);
    }
  }

  toggleAudio = () => {
    if (this.audioElement) {
        if (this.state.audioPlaying) {
            this.audioElement.pause();
        } else {
            this.audioElement.play();
        }
    }
    this.setState({ audioPlaying: !this.state.audioPlaying });
};

render() {
  if (this.state.showInitialSequence) {
    return <InitialSequence onFinished={() => this.setState({ showInitialSequence: false }, this.handleSequenceFinish)} />;
  }
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
      
        {this.state.showModal ? (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 1000,
            }}
            onClick={this.handleClose}
          >
            <img src={image} alt="Popup" style={{ maxHeight: '50%', maxWidth: '70%', border: '20px double white' }} />
             </div>
        ) : null}
       <div style={{ display: 'flex', justifyContent: 'center' }}>
          
          <div className ="mainbg" style={{ width: '75%', height: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <audio 
                id="backgroundAudio" 
                src={audioFile} 
                loop 
                ref={audio => { this.audioElement = audio }}
              >
                Your browser does not support the audio element.
              </audio>
              <button 
                  onClick={this.toggleAudio} 
                  style={{ 
                    fontSize: '1vw', 
                    width: '13vw', 
                    height: 'auto', 
                    fontWeight:'bold', 
                    padding: '15px', 
                    border: '10px double white', 
                    marginTop: '20px', 
                    marginLeft: '40px', 
                    backgroundColor: this.state.audioPlaying ? '#57ed0c' : '#7a7a7a', 
                    color: 'white',
                    boxShadow: '0px 5px 15px rgba(0,0,0,0.3)', // adds a soft shadow to give a lifting effect
                    borderRadius: '80px', // round the corners a bit for a better 3D effect
                    transition: 'all 0.3s ease', // transition effect for the button when pressed
                  }}
                  onMouseDown={e => e.currentTarget.style.transform = 'scale(0.95)'} // reduce size a bit when pressed
                  onMouseUp={e => e.currentTarget.style.transform = ''} // return to original size when released
                  onMouseLeave={e => e.currentTarget.style.transform = ''} // return to original size when mouse leaves
                >
                  {this.state.audioPlaying ? 'Pause Audio' : 'Play Audio'}
                </button>

              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {this.state.account ? (
                  <button disabled style={{ fontSize: '1vw', width: '13vw', height: 'auto', fontWeight:'bold', padding: '15px', border: '10px double white', marginTop: '20px', marginRight: '40px', backgroundColor: '#57ed0c', color: 'white' , borderRadius: '80px' }}>
                    Wallet Connected
                  </button>
                ) : (
                  <button 
                    onClick={this.handleConnectButton} 
                    style={{ 
                      fontSize: '1vw', 
                      width: '13vw', 
                      height: 'auto',
                      fontWeight:'bold', 
                      padding: '15px', 
                      border: '10px double white', 
                      marginTop: '20px', 
                      marginRight: '40px', 
                      backgroundColor: '#7a7a7a', 
                      color: 'white',
                      boxShadow: '0px 5px 15px rgba(0,0,0,0.3)', // adds a soft shadow to give a lifting effect
                      borderRadius: '80px', // round the corners a bit for a better 3D effect
                      transition: 'all 0.3s ease', // transition effect for the button when pressed
                    }}
                    onMouseDown={e => e.currentTarget.style.transform = 'scale(0.95)'} // reduce size a bit when pressed
                    onMouseUp={e => e.currentTarget.style.transform = ''} // return to original size when released
                    onMouseLeave={e => e.currentTarget.style.transform = ''} // return to original size when mouse leaves
                  >
                    Connect Wallet
                  </button>

                )}
              </div>
            </div>
            {this.state.error && <p>{this.state.error}</p>}
            <ConnectWallet 
              connect={this.state.connectWallet} 
              onConnect={this.onConnect} 
              onError={this.onError} 
              web3={this.state.web3}
            />
            <GameDetails 
              account={this.state.account} 
              web3={this.state.web3}
            />
            <EnterGame 
              account={this.state.account} 
              web3={this.state.web3}
            />
            <ClaimPrizes 
              account={this.state.account} 
              web3={this.state.web3}
            />
            <canvas ref={this.canvasRef} style={{ position: 'fixed', top: 0, left: 0, zIndex: 1, pointerEvents: 'none' }} width={window.innerWidth} height={window.innerHeight} />

          </div>
        </div>
      </div>
    );
  }
}



export default App;
